import moment from 'moment';
import 'moment/locale/es';

const createPassenger = (type, number) => ({
  passengerType: type,
  ...(type === 0 ? { adultNumber: number } : {}),
  ...(type === 1 ? { childNumber: number } : {}),
  ...(type === 2 ? { babyNumber: number } : {}),
  name: '',
  lastname: '',
  typeDNI: 'DNI',
  dni: '',
  birthDay: '',
  birthMonth: '',
  birthYear: '',
  country: 'Argentina',
  gender: '',
  birth: '',
  cuitType: '',
  cuitNumber: '',
  codePhone: '54',
});

export const obtainQuantityPassenger = (data = {}) => {
  let adults = [];
  let childs = [];
  let babys = [];
  let countAdult = 1;
  let countChild = 1;
  let countBaby = 1;

  for (let i = 0; i < (data?.adults_qty || 0); i++) {
    adults.push(createPassenger(0, countAdult++));
  }

  (data.childs || []).forEach(child => {
    if (child.age >= 12) {
      adults.push(createPassenger(0, countAdult++));
    } else if (child.age >= 2) {
      childs.push(createPassenger(1, countChild++));
    } else {
      babys.push(createPassenger(2, countBaby++));
    }
  });

  return adults.concat(childs, babys);
};

export const contactInfo = { email: '', repeatEmail: '' };

export const noTravelContact = {
  name: '',
  lastname: '',
  email: '',
  codePhone: '54',
  caracteristicPhone: '',
  phone: '',
};

export const obtainArrayErrorsPassengers = data => {
  let errors = [];
  data.forEach(dat => {
    let newObject = {};
    Object.keys(dat).forEach(key => {
      newObject[key] = {
        error: false,
        text: '',
      };
    });
    errors.push(newObject);
  });
  return errors;
};

const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

export const dateToLocalString = date => {
  moment.locale('es');
  if (!date) return '';

  const datePart = capitalize(moment(date).format('dddd DD MMMM'));

  const timePart = moment(date).format('HH:mm');

  return `${datePart} ${timePart} hs`;
};

export const passengerForBodyPNR = (passangers, voucher) => {
  let newPassengers = [];

  const passengerTypeMap = {
    0: 'ADT',
    1: 'CHD',
    2: 'INF',
  };

  passangers.forEach(passenger => {
    newPassengers.push({
      type: passengerTypeMap[passenger.passengerType],
      last_name: passenger.lastname,
      first_name: passenger.name,
      date_of_birth: passenger.birth,
      sex: passenger.gender === 'masculino' ? 'M' : 'F',
      travel_document: {
        type: passenger.typeDNI === 'DNI' ? '1' : '2',
        country: passenger.country,
        number: passenger.dni,
        valid_thru: '2033-01-01',
      },
      contact: {
        telephone: `${passangers[0]?.codePhone}${passangers[0]?.caracteristicPhone}${passangers[0]?.phone}`,
        code_phone: passangers[0]?.codePhone,
        email: voucher.email,
        phone: `${passangers[0]?.caracteristicPhone}${passangers[0]?.phone}`,
      },
      accounting_document: passenger.cuitType
        ? {
            type: passenger.cuitType ? passenger.cuitType : null,
            country: passenger.cuitType ? 'Argentina' : null,
            number: passenger.cuitNumber ? passenger.cuitNumber : null,
          }
        : null,
    });
  });
  return newPassengers;
};

export const flightIncludes = (backpack, hand, hold) => {
  const combinations = {
    '000': null,
    100: 'mochila',
    '010': 'equipaje de mano',
    '001': 'equipaje en bodega',
    110: 'mochila y equipaje de mano',
    101: 'mochila y equipaje en bodega',
    '011': 'equipaje de mano y bodega',
    111: 'mochila, equipaje de mano y bodega',
  };

  const key = `${+backpack}${+hand}${+hold}`;

  const value = combinations[key];
  return value ? `El vuelo incluye ${value}` : null;
};

export const calculateAge = (dateString, fechaSalida) => {
  let today = new Date(fechaSalida);
  let birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

export const obtenerNombresRepetidos = (passengers = []) =>
  Object.values(
    passengers
      ?.map((p, i) => ({
        nombreCompleto: [
          ...(p.name?.toLowerCase().trim().split(/\s+/) || []),
          ...(p.lastname?.toLowerCase().trim().split(/\s+/) || []),
        ]
          .filter(Boolean)
          .join(' '),
        index: i,
        adultNumber: p.adultNumber,
      }))
      .reduce((acc, { nombreCompleto, index, adultNumber }) => {
        if (!nombreCompleto) return acc;

        if (!acc[nombreCompleto]) {
          acc[nombreCompleto] = [];
        }

        acc[nombreCompleto].push({
          index,
          adultNumber,
        });

        return acc;
      }, {})
  )
    .flatMap(group => (group.length > 1 ? group.map(({ index }) => index) : []))
    .filter((v, i, a) => a.indexOf(v) === i);
